<h3 class="titlebar">{{ "Template.CustomerCockpitComponent.subHeader_mediaCockpit" | translate }}</h3>

<h4 class="fs-5">{{ "Template.CustomerCockpitComponent.subHeader_downloadProductData" | translate }}</h4>
<p>{{ "Template.CustomerCockpitComponent.text_downloadExplanation" | translate }}</p>

<div class="row align-items-end">
  <div class="col-2 mt-4">
    @if (!allDataStreamsChecked) {
      <button (click)="selectAllDataStreams()" class="btn btn-block btn-sm btn-outline-secondary">
        <fa-icon icon="check-double"></fa-icon>
        {{ "Template.CustomerCockpitComponent.btn_selectAll" | translate }}
      </button>
    }

    @if (allDataStreamsChecked) {
      <button (click)="unselectAllDataStreams()" class="btn btn-block btn-sm btn-outline-danger">
        <fa-icon icon="check-double"></fa-icon>
        {{ "Template.CustomerCockpitComponent.btn_unselectAll" | translate }}
      </button>
    }
  </div>

  <div class="col-3 mt-4">
    @if (loadingRequestableDataStreams || requestableDataStreams.length) {
      <button (click)="showRequestableDataStreams()" class="btn btn-block btn-sm btn-outline-primary" [disabled]="loadingRequestableDataStreams || !requestableDataStreams.length">
        <fa-icon icon="cloud" class="me-1"></fa-icon>
        {{ "Template.CustomerCockpitComponent.btn_requestData" | translate }}
        @if (loadingRequestableDataStreams) {
          <fa-icon icon="spinner" animation="spin" class="ms-1"></fa-icon>
        }
      </button>
    }
  </div>

  <div class="col-2 text-center">
    <p class="mb-1">
      <small>{{ "Template.CustomerCockpitComponent.label_view" | translate }}</small>
    </p>

    <div class="btn-group">
      <button (click)="switchView('TILE')" class="btn btn-tile" [class]="{ 'btn-secondary': viewSetting == 'TILE', 'btn-light': viewSetting != 'TILE' }">
        <fa-icon icon="th" size="lg"></fa-icon>
      </button>
      <button (click)="switchView('LIST')" class="btn btn-list" [class]="{ 'btn-secondary': viewSetting == 'LIST', 'btn-light': viewSetting != 'LIST' }">
        <fa-icon icon="align-justify" size="lg"></fa-icon>
      </button>
    </div>
  </div>

  <div class="col-4 offset-1">
    <div class="input-group">
      <span class="input-group-text">
        <fa-icon icon="search"></fa-icon>
      </span>
      <input type="text" class="form-control" placeholder="{{ 'Template.CustomerCockpitComponent.placeholder_search' | translate }}" [(ngModel)]="searchText" #searchbar />
      <button class="btn btn-light border" type="button" (click)="clearSearch()">
        <fa-icon icon="times-circle"></fa-icon>
      </button>
    </div>
  </div>
</div>

@if (loadingDataStreams) {
  <div class="text-center px-5 mt-5">
    <fa-icon icon="spinner" animation="spin" size="3x"></fa-icon>
  </div>
}

@if (!loadingDataStreams && !dataStreamGroupIds?.length) {
  <p class="alert alert-danger mt-3">{{ "Template.CustomerCockpitComponent.text_noAssortmentsEnabled" | translate }}</p>
}

@if (dataStreamGroupIds?.length) {
  <div class="mt-4">
    <div class="row mb-4">
      <div class="col-12">
        <div class="datastreams search-container" [class]="{ tile: viewSetting == 'TILE', list: viewSetting == 'LIST' }">
          <form [formGroup]="downloadForm" (ngSubmit)="requestDownload()">
            @for (dataStreamGroupId of dataStreamGroupIds; track dataStreamGroupId) {
              <app-data-stream-group [dataStreamGroupId]="dataStreamGroupId" [viewSetting]="viewSetting" [parentFormGroup]="downloadForm" [select]="selectSubject" [searchText]="searchText" [refresh]="dataStreamRefreshSubject" class="d-block mb-4"></app-data-stream-group>
            }
            <div class="row align-items-center mb-3">
              <div class="col-auto">
                <label for="format" class="form-label mb-0">
                  <strong>{{ "Template.CustomerCockpitComponent.label_fileFormat" | translate }}</strong>
                </label>
              </div>
              <div class="col">
                <select class="form-select form-select-sm w-auto" formControlName="format" id="format">
                  <option value="XLSX">Excel (XLSX)</option>
                  <option value="CSV">CSV</option>
                </select>
              </div>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="agbCheck" formControlName="agreedAgb" />
              <label class="form-check-label" for="agbCheck">{{ "Template.CustomerCockpitComponent.label_agreedAgb" | translate }}</label>
            </div>
            <button type="submit" class="btn btn-secondary mt-3" [disabled]="!downloadForm.valid || loadingDataStreams">
              <fa-icon icon="download"></fa-icon>
              {{ "Template.CustomerCockpitComponent.btn_requestDownload" | translate }}
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
}

<app-ftp-info></app-ftp-info>

<ng-template #requestableDataStreamsModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">{{ "Template.CustomerCockpitComponent.subHeader_requestProductData" | translate }}</h5>
    <button type="button" class="btn-close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>{{ "Template.CustomerCockpitComponent.text_requestExplanation" | translate }}</p>

    @if (requestableDataStreams?.length) {
      <div class="row">
        @for (dataStream of requestableDataStreams; track dataStream) {
          <app-request-data-stream [dataStream]="dataStream" (refresh)="refreshDataStreams()" class="col-12 col-md-6 col-lg-4 mb-3 datastream"></app-request-data-stream>
        }
      </div>
    }
  </div>
</ng-template>
